import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TOKOverview from './TOKOverview';
import TOKSubpageView from './TOKSubpageView';

const TOKMainView = () => {
  return (
    <Routes>
      <Route path="/" element={<TOKOverview />} />
      <Route path="/subpage/:subpageId" element={<TOKSubpageView />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default TOKMainView; 